<div class="pt-5 bg-white">
    <div class="row ml-0">
        <div class="col-1"></div>
        <div class="col-7">
            <div class="header-content">Resources</div>
            <div class="sub-content mt-3">Manage self care, resources, and safety plans available to service users.</div>
        </div>
        <div class="col-3 d-flex align-items-center justify-content-end">
            <button class="btn d-flex align-items-center justify-content-center primary-bg text-white" (click)="openCreateDialog()" style="white-space:nowrap;padding:8px 20px;">
                <mat-icon style="margin-right:8px;font-size:20px;width:20px;height:20px;line-height:20px;">add</mat-icon>
                <span>Add Resource</span>
            </button>
        </div>
        <div class="col-1"></div>
    </div>

    <!-- Tabs -->
    <div class="row ml-0 mt-4">
        <div class="col-1"></div>
        <div class="col-10">
            <div class="resource-tabs d-flex">
                <div class="resource-tab" [ngClass]="{'tab-selected': activeTab === 'self_care'}" (click)="selectTab('self_care')">Self Care</div>
                <div class="resource-tab" [ngClass]="{'tab-selected': activeTab === 'resource'}" (click)="selectTab('resource')">Resource</div>
                <div class="resource-tab" [ngClass]="{'tab-selected': activeTab === 'safety_plan'}" (click)="selectTab('safety_plan')">Safety Plan</div>
            </div>
        </div>
        <div class="col-1"></div>
    </div>
</div>

<!-- Resource Table -->
<div class="row ml-0 mt-4">
    <div class="col-1"></div>
    <div class="col-10">
        <table class="resource-table w-100" *ngIf="resourceList.length">
            <thead>
                <tr>
                    <th *ngIf="isSelfCareTab">Sub-type</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Link</th>
                    <th *ngIf="isResourceTab">City</th>
                    <th *ngIf="isResourceTab">Support Type</th>
                    <th *ngIf="isResourceTab">Payment</th>
                    <th *ngIf="isResourceTab">Queer Affirmative</th>
                    <th *ngIf="isResourceTab">Caste Affirmative</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let resource of resourceList">
                    <td *ngIf="isSelfCareTab">
                        <span class="subtype-badge">{{ resourceTypeLabelOf(resource.resource_type_name) }}</span>
                    </td>
                    <td class="name-cell">{{ resource.resource_name }}</td>
                    <td class="body-cell" [innerHTML]="resource.resource_body"></td>
                    <td>
                        <a *ngIf="resource.resource_content_url" [href]="resource.resource_content_url" target="_blank" class="resource-link">
                            <mat-icon class="font-16">open_in_new</mat-icon>
                        </a>
                        <span *ngIf="!resource.resource_content_url" class="text-muted">—</span>
                    </td>
                    <td *ngIf="isResourceTab">{{ resource.city || '—' }}</td>
                    <td *ngIf="isResourceTab">{{ resource.support_type || '—' }}</td>
                    <td *ngIf="isResourceTab">{{ resource.payment || '—' }}</td>
                    <td *ngIf="isResourceTab">
                        <mat-icon *ngIf="resource.is_queer_affirmative" class="affirmative-yes">check_circle</mat-icon>
                        <mat-icon *ngIf="!resource.is_queer_affirmative" class="affirmative-no">cancel</mat-icon>
                    </td>
                    <td *ngIf="isResourceTab">
                        <mat-icon *ngIf="resource.is_caste_affirmative" class="affirmative-yes">check_circle</mat-icon>
                        <mat-icon *ngIf="!resource.is_caste_affirmative" class="affirmative-no">cancel</mat-icon>
                    </td>
                    <td>
                        <button class="btn btn-sm action-btn mr-2" (click)="openEditDialog(resource)" title="Edit">
                            <mat-icon class="font-18">edit</mat-icon>
                        </button>
                        <button class="btn btn-sm action-btn-danger" (click)="confirmDelete(resource)" title="Delete">
                            <mat-icon class="font-18">delete</mat-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="sub-content mt-5 text-center" *ngIf="!resourceList.length">
            No resources found. Click "Add Resource" to create one.
        </div>
    </div>
    <div class="col-1"></div>
</div>

<!-- Create / Edit Dialog trigger (hidden) -->
<button class="d-none" id="resourceDialogTrigger" data-target="#resource-dialog" data-toggle="modal"></button>

<!-- Create / Edit Dialog -->
<div class="modal" id="resource-dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content sub-content" style="border-radius: 10px;">
            <div class="modal-header">
                <h5 class="modal-title">{{ isEditing ? 'Edit Resource' : 'Add Resource' }}</h5>
                <button type="button" class="close" data-dismiss="modal" id="resourceDialogClose">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="resourceForm">

                    <!-- Self Care sub-type selector -->
                    <div class="form-group mb-3" *ngIf="isSelfCareTab">
                        <label class="font-weight-bold">Sub-type <span class="text-danger">*</span></label>
                        <select class="form-control mt-2" formControlName="resource_type_name">
                            <option value="">Select sub-type</option>
                            <option *ngFor="let st of selfCareSubtypes" [value]="st.value">{{ st.label }}</option>
                        </select>
                        <div class="text-danger font-12 mt-1" *ngIf="resourceForm.get('resource_type_name')?.touched && resourceForm.get('resource_type_name')?.invalid">
                            Sub-type is required.
                        </div>
                    </div>

                    <div class="form-group mb-3">
                        <label class="font-weight-bold">Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control mt-2" formControlName="resource_name" placeholder="Resource name">
                        <div class="text-danger font-12 mt-1" *ngIf="resourceForm.get('resource_name')?.touched && resourceForm.get('resource_name')?.invalid">
                            Name is required.
                        </div>
                    </div>

                    <div class="form-group mb-3">
                        <label class="font-weight-bold">Description</label>
                        <quill-editor class="mt-2 d-block" formControlName="resource_body" [modules]="quillModules" placeholder="Brief description" style="display:block;"></quill-editor>
                    </div>

                    <div class="form-group mb-3">
                        <label class="font-weight-bold">Link / URL</label>
                        <input type="text" class="form-control mt-2" formControlName="resource_content_url" placeholder="https://...">
                    </div>

                    <!-- Extra fields only for Resource tab -->
                    <ng-container *ngIf="isResourceTab">
                        <div class="row">
                            <div class="col-6 form-group mb-3">
                                <label class="font-weight-bold">City</label>
                                <input type="text" class="form-control mt-2" formControlName="city" placeholder="e.g. Mumbai">
                            </div>
                            <div class="col-6 form-group mb-3">
                                <label class="font-weight-bold">Support Type</label>
                                <input type="text" class="form-control mt-2" formControlName="support_type" placeholder="e.g. Individual therapy">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 form-group mb-3">
                                <label class="font-weight-bold d-block">Payment</label>
                                <div class="d-flex mt-2" style="gap:24px;">
                                    <div class="d-flex align-items-center payment-radio">
                                        <input type="radio" formControlName="payment" value="Free" id="payment_free">
                                        <label class="mb-0 ml-2" for="payment_free">Free</label>
                                    </div>
                                    <div class="d-flex align-items-center payment-radio">
                                        <input type="radio" formControlName="payment" value="Paid" id="payment_paid">
                                        <label class="mb-0 ml-2" for="payment_paid">Paid</label>
                                    </div>
                                    <div class="d-flex align-items-center payment-radio">
                                        <input type="radio" formControlName="payment" value="Subsidised" id="payment_subsidised">
                                        <label class="mb-0 ml-2" for="payment_subsidised">Subsidised</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 form-group mb-3">
                                <label class="font-weight-bold">Issue Kind</label>
                                <input type="text" class="form-control mt-2" formControlName="issue_kind" placeholder="e.g. Anxiety">
                            </div>
                        </div>
                        <div class="form-group mb-3 d-flex align-items-center">
                            <input type="checkbox" class="mr-2" formControlName="is_queer_affirmative" id="queer_affirmative">
                            <label class="mb-0" for="queer_affirmative">Queer Affirmative</label>
                            <input type="checkbox" class="mr-2 ml-4" formControlName="is_caste_affirmative" id="caste_affirmative">
                            <label class="mb-0" for="caste_affirmative">Caste Affirmative</label>
                        </div>
                    </ng-container>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button class="btn primary-bg text-white" (click)="saveResource()" [disabled]="resourceForm.invalid">
                    {{ isEditing ? 'Update' : 'Create' }}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Confirmation trigger (hidden) -->
<button class="d-none" id="resourceDeleteTrigger" data-target="#resource-delete-dialog" data-toggle="modal"></button>

<!-- Delete Confirmation Dialog -->
<div class="modal" id="resource-delete-dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog">
        <div class="modal-content sub-content" style="border-radius: 10px;">
            <div class="modal-body text-center py-4">
                <span class="material-symbols-rounded primary-btn-txt" style="font-size: 60px;">delete</span>
                <h4 class="modal-title mt-2">Are you sure?</h4>
                <p class="mt-2">This resource will be permanently deleted.</p>
                <div class="d-flex align-items-center justify-content-center py-2">
                    <div class="cursor w-25 primary-btn-txt font-15 mr-4" data-dismiss="modal" id="resourceDeleteClose">Cancel</div>
                    <button class="btn d-flex justify-content-center align-items-center ml-3 font-15 w-25 primary-bg text-white" data-dismiss="modal" (click)="deleteResource()">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>
